import { render, staticRenderFns } from "./PublicContractorRIDC.vue?vue&type=template&id=7fed58c2&scoped=true&"
import script from "./PublicContractorRIDC.vue?vue&type=script&lang=ts&"
export * from "./PublicContractorRIDC.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7fed58c2",
  null
  
)

export default component.exports